<template>
    <HeroSection/>
    <BenefitsSection/>
    <GallerySection/>
    <DetailsSection/>
    <CadastralNumbersSection/>
</template>

<script>
import HeroSection from "@js/components/Home/HeroSection.vue";
import BenefitsSection from "@js/components/Home/BenefitsSection.vue";
import DetailsSection from "@js/components/Home/DetailsSection.vue";
import GallerySection from "@js/components/Home/GallerySection.vue";
import CadastralNumbersSection from "@js/components/Home/CadastralNumbersSection.vue";

export default {
    name: 'Home',

    components: {
        CadastralNumbersSection,
        GallerySection,
        DetailsSection,
        BenefitsSection,
        HeroSection,
    },
};
</script>
